import { useTranslation } from 'react-i18next';

/** Accessible loading indicator. */
export function Spinner(): JSX.Element {
  const { t } = useTranslation();
  return <span className="spinner" role="status" aria-label={t('common.loading')} />;
}
